import React, { useState } from 'react';
import { ChevronRightIcon, ChevronLeftIcon, UsersIcon, UserIcon, PencilRulerIcon, BarChart3Icon, PieChartIcon, MapPinIcon, CalendarIcon, EyeIcon, EditIcon, DownloadIcon, ShareIcon, CopyIcon, TrashIcon, GlobeIcon, LayoutIcon, RulerIcon, DropletIcon, TagIcon, ListIcon, LayoutGridIcon, FoldersIcon } from 'lucide-react';
import { FolderView } from './FolderView';
// Mock data for dealer and customer designs
const dealerCustomerDesignsData = [{
  id: 'TZHE32',
  date: 'Jul 18, 2025',
  name: 'Western Irrigation Project',
  description: 'Large field pivot system with 4 pivots',
  dealerName: 'AiscoEurope SAU',
  dealerType: 'Direct Dealer',
  region: 'EUROPE',
  status: 'completed',
  model: 'Pivot CP600',
  pivotCount: 4,
  specs: {
    length: '298.81 m',
    angle: '360°',
    area: '33.27 ha',
    flow: '35.01 l/s',
    pressure: '2.00 bar'
  },
  createdBy: 'Daniel Fernández',
  lastModified: '2025-07-18',
  tags: ['Commercial', 'Multi-Pivot']
}, {
  id: 'T55NVQ',
  date: 'Jul 12, 2025',
  name: 'Нов оросен пункт',
  description: 'Irrigation system for eastern field',
  dealerName: 'HMB Irrigation',
  dealerType: 'Dealer',
  region: 'EUROPE',
  status: 'active',
  model: 'Pivot CP600',
  pivotCount: 1,
  specs: {
    length: '298.81 m',
    angle: '360°',
    area: '33.27 ha',
    flow: '35.01 l/s',
    pressure: '2.00 bar'
  },
  createdBy: 'Maria Petrova',
  lastModified: '2025-07-12',
  tags: ['Standard', 'Single-Pivot']
}, {
  id: 'HX6AA6',
  date: 'Jun 10, 2025',
  name: 'Valley Vineyard Project',
  description: 'Multi-pivot system for vineyard irrigation',
  dealerName: 'AiscoEurope SAU',
  dealerType: 'Direct Dealer',
  region: 'EUROPE',
  status: 'active',
  model: 'Pivot CP600',
  pivotCount: 3,
  specs: {
    length: '298.81 m',
    angle: '360°',
    area: '32.41 ha',
    flow: '40.63 l/s',
    pressure: '2.00 bar'
  },
  createdBy: 'Daniel Fernández',
  lastModified: '2025-06-10',
  tags: ['Vineyard', 'Multi-Pivot']
}, {
  id: '433F0L',
  date: 'Jun 10, 2025',
  name: 'New Pivot Design',
  description: 'Standard pivot for small field',
  dealerName: 'WEAKS MARTIN',
  dealerType: 'Dealer',
  region: 'EUROPE',
  status: 'active',
  model: 'Pivot CP600',
  pivotCount: 1,
  specs: {
    length: '298.81 m',
    angle: '360°',
    area: '32.41 ha',
    flow: '40.63 l/s',
    pressure: '2.00 bar'
  },
  createdBy: 'FERNANDO HERNANDEZ L',
  lastModified: '2025-06-10',
  tags: ['Standard', 'Single-Pivot']
}, {
  id: 'LM7KJ9',
  date: 'Jun 02, 2025',
  name: 'Linear System for Corn Field',
  description: 'Linear irrigation system for rectangular field',
  dealerName: 'VAN DIEMEN LAND IRRIGATION',
  dealerType: 'Dealer',
  region: 'AUSTRALIA',
  status: 'active',
  model: 'Linear',
  pivotCount: 1,
  specs: {
    length: '400.00 m',
    angle: 'N/A',
    area: '40.00 ha',
    flow: '45.00 l/s',
    pressure: '2.50 bar'
  },
  createdBy: 'John Quirk',
  lastModified: '2025-06-02',
  tags: ['Linear', 'Corn']
}, {
  id: 'P98RT2',
  date: 'May 25, 2025',
  name: 'Corner Arm Addition',
  description: 'Corner arm for existing pivot',
  dealerName: 'HMB Irrigation',
  dealerType: 'Dealer',
  region: 'AMERICA',
  status: 'pending',
  model: 'Corner Arm',
  pivotCount: 1,
  specs: {
    length: '65.00 m',
    angle: 'N/A',
    area: '+5.00 ha',
    flow: '+15.00 l/s',
    pressure: '2.20 bar'
  },
  createdBy: 'Benny Ginter',
  lastModified: '2025-05-25',
  tags: ['Corner', 'Upgrade']
}, {
  id: 'KL5MN7',
  date: 'May 15, 2025',
  name: 'High Profile CP600',
  description: 'High clearance pivot for tall crops',
  dealerName: 'Smith Family Farms',
  dealerType: 'Customer',
  region: 'AMERICA',
  status: 'completed',
  model: 'Pivot CP600',
  pivotCount: 1,
  specs: {
    length: '250.00 m',
    angle: '180°',
    area: '25.00 ha',
    flow: '30.00 l/s',
    pressure: '2.10 bar'
  },
  createdBy: 'Maria Rodriguez',
  lastModified: '2025-05-15',
  tags: ['High Profile', 'Half-Circle']
}, {
  id: 'WQ9JK2',
  date: 'May 10, 2025',
  name: 'Napa Valley Drip System',
  description: 'Precision drip system for vineyard',
  dealerName: 'Napa Valley Vineyards',
  dealerType: 'Customer',
  region: 'AMERICA',
  status: 'pending',
  model: 'Drip System',
  pivotCount: 0,
  specs: {
    length: 'N/A',
    angle: 'N/A',
    area: '15.00 ha',
    flow: '10.00 l/s',
    pressure: '1.50 bar'
  },
  createdBy: 'James Wilson',
  lastModified: '2025-05-10',
  tags: ['Drip', 'Vineyard']
}];
export function DealerCustomerDesigns({
  searchQuery,
  selectedDealer,
  selectedRegion,
  selectedModel
}) {
  const [currentPage, setCurrentPage] = useState(1);
  const [viewType, setViewType] = useState('grid'); // 'grid', 'list', or 'folders'
  const [dealerFilter, setDealerFilter] = useState('all'); // 'all', 'dealer', 'customer'
  const [statusFilter, setStatusFilter] = useState('all'); // 'all', 'active', 'completed', 'pending'
  const itemsPerPage = viewType === 'grid' ? 6 : 8;
  // Filter designs based on search query, filters, and dealer type
  const filteredDesigns = dealerCustomerDesignsData.filter(design => {
    const matchesSearch = searchQuery === '' || design.id.toLowerCase().includes(searchQuery.toLowerCase()) || design.name.toLowerCase().includes(searchQuery.toLowerCase()) || design.description.toLowerCase().includes(searchQuery.toLowerCase()) || design.createdBy.toLowerCase().includes(searchQuery.toLowerCase()) || design.dealerName.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesDealer = selectedDealer === 'all' || design.dealerName.toLowerCase().includes(selectedDealer.toLowerCase());
    const matchesRegion = selectedRegion === 'all' || design.region.toLowerCase() === selectedRegion.toLowerCase();
    const matchesModel = selectedModel === 'all' || design.model.toLowerCase().includes(selectedModel.toLowerCase());
    const matchesDealerType = dealerFilter === 'all' || dealerFilter === 'dealer' && design.dealerType.includes('Dealer') || dealerFilter === 'customer' && design.dealerType === 'Customer';
    const matchesStatus = statusFilter === 'all' || design.status === statusFilter;
    return matchesSearch && matchesDealer && matchesRegion && matchesModel && matchesDealerType && matchesStatus;
  });
  // Calculate pagination
  const totalPages = Math.ceil(filteredDesigns.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const paginatedDesigns = filteredDesigns.slice(startIndex, startIndex + itemsPerPage);
  // Calculate summary statistics
  const totalDesigns = filteredDesigns.length;
  const dealerCount = filteredDesigns.filter(d => d.dealerType.includes('Dealer')).length;
  const customerCount = filteredDesigns.filter(d => d.dealerType === 'Customer').length;
  const totalPivots = filteredDesigns.reduce((sum, design) => sum + design.pivotCount, 0);
  const handleViewDesign = design => {
    console.log('Viewing design:', design);
    // Aquí implementarías la lógica para ver un diseño
  };
  return <div data-id="element-2363">
      {/* Dashboard summary */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6 p-6 border-b border-gray-200 bg-gray-50" data-id="element-2364">
        <div className="bg-white border border-gray-200 rounded-xl p-5 shadow-sm" data-id="element-2365">
          <div className="flex justify-between items-start" data-id="element-2366">
            <div data-id="element-2367">
              <h3 className="text-gray-500 text-sm font-medium mb-1" data-id="element-2368">
                Total Designs
              </h3>
              <p className="text-4xl font-bold text-blue-600" data-id="element-2369">{totalDesigns}</p>
            </div>
            <div className="bg-blue-100 p-2 rounded-lg" data-id="element-2370">
              <PencilRulerIcon size={24} className="text-blue-600" data-id="element-2371" />
            </div>
          </div>
          <div className="mt-4 flex gap-3" data-id="element-2372">
            <button className={`text-xs px-3 py-1.5 rounded-full flex items-center ${dealerFilter === 'all' ? 'bg-blue-100 text-blue-700' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} onClick={() => setDealerFilter('all')} data-id="element-2373">
              All ({totalDesigns})
            </button>
            <button className={`text-xs px-3 py-1.5 rounded-full flex items-center ${dealerFilter === 'dealer' ? 'bg-indigo-100 text-indigo-700' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} onClick={() => setDealerFilter('dealer')} data-id="element-2374">
              <UserIcon size={12} className="mr-1" data-id="element-2375" />
              Dealers ({dealerCount})
            </button>
            <button className={`text-xs px-3 py-1.5 rounded-full flex items-center ${dealerFilter === 'customer' ? 'bg-teal-100 text-teal-700' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} onClick={() => setDealerFilter('customer')} data-id="element-2376">
              <UserIcon size={12} className="mr-1" data-id="element-2377" />
              Customers ({customerCount})
            </button>
          </div>
        </div>
        <div className="bg-white border border-gray-200 rounded-xl p-5 shadow-sm" data-id="element-2378">
          <div className="flex justify-between items-start" data-id="element-2379">
            <div data-id="element-2380">
              <h3 className="text-gray-500 text-sm font-medium mb-1" data-id="element-2381">
                Total Pivots
              </h3>
              <p className="text-4xl font-bold text-indigo-600" data-id="element-2382">
                {totalPivots}
              </p>
            </div>
            <div className="bg-indigo-100 p-2 rounded-lg" data-id="element-2383">
              <LayoutIcon size={24} className="text-indigo-600" data-id="element-2384" />
            </div>
          </div>
          <div className="mt-4 flex gap-3" data-id="element-2385">
            <button className={`text-xs px-3 py-1.5 rounded-full flex items-center ${selectedModel === 'all' ? 'bg-indigo-100 text-indigo-700' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} onClick={() => setSelectedModel('all')} data-id="element-2386">
              All Models
            </button>
            <button className={`text-xs px-3 py-1.5 rounded-full flex items-center ${selectedModel === 'cp600' ? 'bg-indigo-100 text-indigo-700' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} onClick={() => setSelectedModel('cp600')} data-id="element-2387">
              CP600
            </button>
            <button className={`text-xs px-3 py-1.5 rounded-full flex items-center ${selectedModel === 'linear' ? 'bg-indigo-100 text-indigo-700' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} onClick={() => setSelectedModel('linear')} data-id="element-2388">
              Linear
            </button>
          </div>
        </div>
        <div className="bg-white border border-gray-200 rounded-xl p-5 shadow-sm" data-id="element-2389">
          <div className="flex justify-between items-start" data-id="element-2390">
            <div data-id="element-2391">
              <h3 className="text-gray-500 text-sm font-medium mb-1" data-id="element-2392">Status</h3>
              <div className="flex items-center mt-2 gap-2" data-id="element-2393">
                <div className="w-full bg-gray-200 rounded-full h-2.5" data-id="element-2394">
                  <div className="bg-green-500 h-2.5 rounded-full" style={{
                  width: `${filteredDesigns.filter(d => d.status === 'completed').length / totalDesigns * 100}%`
                }} data-id="element-2395"></div>
                </div>
              </div>
            </div>
            <div className="bg-green-100 p-2 rounded-lg" data-id="element-2396">
              <PieChartIcon size={24} className="text-green-600" data-id="element-2397" />
            </div>
          </div>
          <div className="mt-4 flex gap-3" data-id="element-2398">
            <button className={`text-xs px-3 py-1.5 rounded-full flex items-center ${statusFilter === 'all' ? 'bg-gray-100 text-gray-700 font-medium' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} onClick={() => setStatusFilter('all')} data-id="element-2399">
              All
            </button>
            <button className={`text-xs px-3 py-1.5 rounded-full flex items-center ${statusFilter === 'active' ? 'bg-blue-100 text-blue-700' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} onClick={() => setStatusFilter('active')} data-id="element-2400">
              Active
            </button>
            <button className={`text-xs px-3 py-1.5 rounded-full flex items-center ${statusFilter === 'completed' ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} onClick={() => setStatusFilter('completed')} data-id="element-2401">
              Completed
            </button>
            <button className={`text-xs px-3 py-1.5 rounded-full flex items-center ${statusFilter === 'pending' ? 'bg-amber-100 text-amber-700' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} onClick={() => setStatusFilter('pending')} data-id="element-2402">
              Pending
            </button>
          </div>
        </div>
        <div className="bg-white border border-gray-200 rounded-xl p-5 shadow-sm" data-id="element-2403">
          <div className="flex justify-between items-start" data-id="element-2404">
            <div data-id="element-2405">
              <h3 className="text-gray-500 text-sm font-medium mb-1" data-id="element-2406">
                Regions
              </h3>
              <div className="mt-2" data-id="element-2407">
                <div className="flex justify-between text-sm mb-1" data-id="element-2408">
                  <span data-id="element-2409">Europe</span>
                  <span className="font-medium" data-id="element-2410">
                    {filteredDesigns.filter(d => d.region === 'EUROPE').length}
                  </span>
                </div>
                <div className="flex justify-between text-sm mb-1" data-id="element-2411">
                  <span data-id="element-2412">America</span>
                  <span className="font-medium" data-id="element-2413">
                    {filteredDesigns.filter(d => d.region === 'AMERICA').length}
                  </span>
                </div>
                <div className="flex justify-between text-sm" data-id="element-2414">
                  <span data-id="element-2415">Australia</span>
                  <span className="font-medium" data-id="element-2416">
                    {filteredDesigns.filter(d => d.region === 'AUSTRALIA').length}
                  </span>
                </div>
              </div>
            </div>
            <div className="bg-teal-100 p-2 rounded-lg" data-id="element-2417">
              <GlobeIcon size={24} className="text-teal-600" data-id="element-2418" />
            </div>
          </div>
          <div className="mt-4 flex gap-3" data-id="element-2419">
            <button className={`text-xs px-3 py-1.5 rounded-full flex items-center ${selectedRegion === 'all' ? 'bg-teal-100 text-teal-700' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} onClick={() => setSelectedRegion('all')} data-id="element-2420">
              All Regions
            </button>
          </div>
        </div>
      </div>

      {/* View type toggle */}
      <div className="flex justify-between items-center px-6 py-3 bg-white border-b border-gray-200" data-id="element-2421">
        <div className="text-gray-700 font-medium" data-id="element-2422">
          {viewType !== 'folders' ? `${startIndex + 1}-${Math.min(startIndex + itemsPerPage, filteredDesigns.length)} of ${filteredDesigns.length} designs` : `${filteredDesigns.length} designs`}
        </div>
        <div className="flex border border-gray-200 rounded-lg overflow-hidden" data-id="element-2423">
          <button className={`px-3 py-1.5 flex items-center ${viewType === 'list' ? 'bg-blue-50 text-blue-600' : 'bg-white text-gray-600'}`} onClick={() => setViewType('list')} data-id="element-2424">
            <ListIcon size={16} className="mr-1" data-id="element-2425" />
            List
          </button>
          <button className={`px-3 py-1.5 flex items-center ${viewType === 'grid' ? 'bg-blue-50 text-blue-600' : 'bg-white text-gray-600'}`} onClick={() => setViewType('grid')} data-id="element-2426">
            <LayoutGridIcon size={16} className="mr-1" data-id="element-2427" />
            Grid
          </button>
          <button className={`px-3 py-1.5 flex items-center ${viewType === 'folders' ? 'bg-blue-50 text-blue-600' : 'bg-white text-gray-600'}`} onClick={() => setViewType('folders')} data-id="element-2428">
            <FoldersIcon size={16} className="mr-1" data-id="element-2429" />
            Folders
          </button>
        </div>
      </div>

      {/* Designs list, grid or folders */}
      {viewType === 'folders' ? <div className="h-[calc(100vh-400px)] min-h-[400px]" data-id="element-2430">
          <FolderView designs={filteredDesigns} onViewDesign={handleViewDesign} data-id="element-2431" />
        </div> : viewType === 'grid' ? <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 p-6" data-id="element-2432">
          {paginatedDesigns.map(design => <DesignCard key={design.id} design={design} data-id="element-2433" />)}
          {paginatedDesigns.length === 0 && <div className="col-span-3 text-center py-12 text-gray-500" data-id="element-2434">
              No designs found matching your search criteria
            </div>}
        </div> : <div className="overflow-x-auto" data-id="element-2435">
          <table className="w-full" data-id="element-2436">
            <thead className="bg-gray-50" data-id="element-2437">
              <tr data-id="element-2438">
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2439">
                  ID
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2440">
                  Name
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2441">
                  Dealer/Customer
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2442">
                  Model
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2443">
                  Specs
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2444">
                  Region
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2445">
                  Status
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2446">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200" data-id="element-2447">
              {paginatedDesigns.map(design => <tr key={design.id} className="hover:bg-gray-50" data-id="element-2448">
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-2449">
                    {design.id}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700" data-id="element-2450">
                    <div className="font-medium" data-id="element-2451">{design.name}</div>
                    <div className="text-gray-500 text-xs" data-id="element-2452">
                      {design.description}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700" data-id="element-2453">
                    <div data-id="element-2454">{design.dealerName}</div>
                    <div className="text-xs text-gray-500" data-id="element-2455">
                      {design.dealerType}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700" data-id="element-2456">
                    {design.model}
                    <div className="text-xs text-gray-500" data-id="element-2457">
                      {design.pivotCount}{' '}
                      {design.pivotCount === 1 ? 'unit' : 'units'}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700" data-id="element-2458">
                    <div className="flex gap-2 text-xs" data-id="element-2459">
                      <span className="bg-blue-50 text-blue-700 px-2 py-0.5 rounded-full" data-id="element-2460">
                        {design.specs.length}
                      </span>
                      <span className="bg-indigo-50 text-indigo-700 px-2 py-0.5 rounded-full" data-id="element-2461">
                        {design.specs.angle}
                      </span>
                      <span className="bg-green-50 text-green-700 px-2 py-0.5 rounded-full" data-id="element-2462">
                        {design.specs.area}
                      </span>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700" data-id="element-2463">
                    {design.region}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-2464">
                    <StatusBadge status={design.status} data-id="element-2465" />
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-2466">
                    <div className="flex space-x-2" data-id="element-2467">
                      <button className="text-blue-600 hover:text-blue-800" data-id="element-2468">
                        <EyeIcon size={16} data-id="element-2469" />
                      </button>
                      <button className="text-gray-600 hover:text-gray-800" data-id="element-2470">
                        <EditIcon size={16} data-id="element-2471" />
                      </button>
                      <button className="text-gray-600 hover:text-gray-800" data-id="element-2472">
                        <ShareIcon size={16} data-id="element-2473" />
                      </button>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
          {paginatedDesigns.length === 0 && <div className="text-center py-12 text-gray-500" data-id="element-2474">
              No designs found matching your search criteria
            </div>}
        </div>}

      {/* Pagination - Only show if not in folder view */}
      {totalPages > 1 && viewType !== 'folders' && <div className="flex justify-between items-center px-6 py-4 border-t border-gray-200 bg-gray-50" data-id="element-2475">
          <button className="flex items-center text-gray-700 hover:text-blue-600 disabled:text-gray-400" onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))} disabled={currentPage === 1} data-id="element-2476">
            <ChevronLeftIcon size={16} className="mr-1" data-id="element-2477" />
            Previous
          </button>
          <div className="flex items-center gap-1" data-id="element-2478">
            {Array.from({
          length: totalPages
        }, (_, i) => i + 1).map(page => <button key={page} className={`w-8 h-8 rounded-full flex items-center justify-center ${currentPage === page ? 'bg-blue-600 text-white' : 'text-gray-700 hover:bg-gray-100'}`} onClick={() => setCurrentPage(page)} data-id="element-2479">
                {page}
              </button>)}
          </div>
          <button className="flex items-center text-gray-700 hover:text-blue-600 disabled:text-gray-400" onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))} disabled={currentPage === totalPages} data-id="element-2480">
            Next
            <ChevronRightIcon size={16} className="ml-1" data-id="element-2481" />
          </button>
        </div>}
    </div>;
}
// Helper component for design cards
function DesignCard({
  design
}) {
  const getStatusColor = status => {
    switch (status) {
      case 'active':
        return 'bg-blue-100 text-blue-700 border-blue-200';
      case 'completed':
        return 'bg-green-100 text-green-700 border-green-200';
      case 'pending':
        return 'bg-amber-100 text-amber-700 border-amber-200';
      default:
        return 'bg-gray-100 text-gray-700 border-gray-200';
    }
  };
  return <div className="bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm hover:shadow-md transition-shadow duration-300" data-id="element-2482">
      <div className="p-5 border-b border-gray-100" data-id="element-2483">
        <div className="flex justify-between items-start" data-id="element-2484">
          <div data-id="element-2485">
            <div className="flex items-center" data-id="element-2486">
              <h3 className="font-bold text-gray-900 truncate max-w-[200px]" data-id="element-2487">
                {design.name}
              </h3>
              <span className="ml-2 bg-gray-100 text-gray-600 text-xs px-2 py-0.5 rounded-full" data-id="element-2488">
                {design.id}
              </span>
            </div>
            <p className="text-gray-600 text-sm mt-1" data-id="element-2489">{design.description}</p>
          </div>
          <span className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(design.status)}`} data-id="element-2490">
            {design.status.charAt(0).toUpperCase() + design.status.slice(1)}
          </span>
        </div>
        <div className="mt-4 flex items-center" data-id="element-2491">
          <div className="h-10 w-10 rounded-full bg-indigo-100 flex items-center justify-center mr-3" data-id="element-2492">
            <UserIcon size={18} className="text-indigo-600" data-id="element-2493" />
          </div>
          <div data-id="element-2494">
            <div className="text-sm font-medium text-gray-900" data-id="element-2495">
              {design.dealerName}
            </div>
            <div className="text-xs text-gray-500" data-id="element-2496">{design.dealerType}</div>
          </div>
        </div>
      </div>
      <div className="px-5 py-4 flex justify-between items-center bg-gray-50 border-b border-gray-100" data-id="element-2497">
        <div className="flex items-center" data-id="element-2498">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ddVxmMM9BG37mQQDtAXhse/8120_pierce.svg" alt="Pivot Machine" className="h-12 mr-3" data-id="element-2499" />
          <div data-id="element-2500">
            <div className="text-sm font-medium text-gray-900" data-id="element-2501">
              {design.model}
            </div>
            <div className="text-xs text-gray-500" data-id="element-2502">
              {design.pivotCount} {design.pivotCount === 1 ? 'unit' : 'units'}
            </div>
          </div>
        </div>
        <div className="text-right" data-id="element-2503">
          <div className="text-sm font-medium text-gray-900" data-id="element-2504">
            {design.region}
          </div>
          <div className="text-xs text-gray-500 flex items-center justify-end" data-id="element-2505">
            <CalendarIcon size={12} className="mr-1" data-id="element-2506" />
            {design.date}
          </div>
        </div>
      </div>
      <div className="px-5 py-4" data-id="element-2507">
        <h4 className="text-xs font-medium text-gray-500 mb-2" data-id="element-2508">
          SPECIFICATIONS
        </h4>
        <div className="grid grid-cols-3 gap-2" data-id="element-2509">
          <div className="bg-blue-50 rounded-lg p-2 text-center" data-id="element-2510">
            <div className="text-xs text-blue-600 mb-1 flex items-center justify-center" data-id="element-2511">
              <RulerIcon size={12} className="mr-1" data-id="element-2512" />
              Length
            </div>
            <div className="text-sm font-medium text-gray-900" data-id="element-2513">
              {design.specs.length}
            </div>
          </div>
          <div className="bg-indigo-50 rounded-lg p-2 text-center" data-id="element-2514">
            <div className="text-xs text-indigo-600 mb-1 flex items-center justify-center" data-id="element-2515">
              <PieChartIcon size={12} className="mr-1" data-id="element-2516" />
              Area
            </div>
            <div className="text-sm font-medium text-gray-900" data-id="element-2517">
              {design.specs.area}
            </div>
          </div>
          <div className="bg-teal-50 rounded-lg p-2 text-center" data-id="element-2518">
            <div className="text-xs text-teal-600 mb-1 flex items-center justify-center" data-id="element-2519">
              <DropletIcon size={12} className="mr-1" data-id="element-2520" />
              Flow
            </div>
            <div className="text-sm font-medium text-gray-900" data-id="element-2521">
              {design.specs.flow}
            </div>
          </div>
        </div>
        <div className="mt-3 flex flex-wrap gap-1" data-id="element-2522">
          {design.tags.map((tag, index) => <span key={index} className="bg-gray-100 text-gray-700 text-xs px-2 py-0.5 rounded-full flex items-center" data-id="element-2523">
              <TagIcon size={10} className="mr-1" data-id="element-2524" />
              {tag}
            </span>)}
        </div>
      </div>
      <div className="px-5 py-3 border-t border-gray-100 flex justify-between" data-id="element-2525">
        <div className="flex space-x-2" data-id="element-2526">
          <button className="text-blue-600 hover:text-blue-800 text-sm font-medium flex items-center" data-id="element-2527">
            <EyeIcon size={14} className="mr-1" data-id="element-2528" />
            View
          </button>
          <button className="text-gray-600 hover:text-gray-800 text-sm font-medium flex items-center" data-id="element-2529">
            <EditIcon size={14} className="mr-1" data-id="element-2530" />
            Edit
          </button>
        </div>
        <div className="flex space-x-2" data-id="element-2531">
          <button className="text-gray-600 hover:text-gray-800" data-id="element-2532">
            <ShareIcon size={16} data-id="element-2533" />
          </button>
          <button className="text-gray-600 hover:text-gray-800" data-id="element-2534">
            <DownloadIcon size={16} data-id="element-2535" />
          </button>
        </div>
      </div>
    </div>;
}
// Helper component for status badges
function StatusBadge({
  status
}) {
  let config = {
    color: 'gray',
    text: 'Unknown'
  };
  switch (status) {
    case 'active':
      config = {
        color: 'blue',
        text: 'Active'
      };
      break;
    case 'completed':
      config = {
        color: 'green',
        text: 'Completed'
      };
      break;
    case 'pending':
      config = {
        color: 'amber',
        text: 'Pending'
      };
      break;
  }
  const colors = {
    blue: 'bg-blue-100 text-blue-800',
    green: 'bg-green-100 text-green-800',
    amber: 'bg-amber-100 text-amber-800',
    gray: 'bg-gray-100 text-gray-800'
  };
  return <span className={`px-2.5 py-0.5 rounded-full text-xs font-medium ${colors[config.color]}`} data-id="element-2536">
      {config.text}
    </span>;
}